module.exports = __webpack_public_path__ + "img/nico_side.09008c5d.png";